<div class="my-news-component-container">
    <ng-template #gotoLink>
        <app-action-link *ngIf="newsCenterUrl" [href]="newsCenterUrl" [target]="'blank'">
            <span i18n="news see all news link@@news-see-all-news-link">Go to the news center</span>
            <i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
        </app-action-link>
        <app-action-router-link *ngIf="!newsCenterUrl" [actionRouterLink]="'../pages/news'" [buttonClass]="'align-middle'">
            <span i18n="news see all news link@@news-see-all-news-link">Go to the news center</span>
            <i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
        </app-action-router-link>
    </ng-template>

    <div class="my-news-item-container">
        <div *ngIf="personalNewsItems$ | async as personalNewsItems; else innerLoading">

            <div *ngIf="personalNewsItems && personalNewsItems.length > 0">
                <app-compact-news-card-list [personalNewsItems]='personalNewsItems'></app-compact-news-card-list>
            </div>

            <div *ngIf="personalNewsItems && personalNewsItems.length === 0">
                <app-text-placeholder>
                    <p i18n="my news none found@@my-news-none-found">No news could be found according to your channel selections.</p>
                </app-text-placeholder>
            </div>

            <div *ngIf="loading" class="mt-4">
                <div *ngIf="errorSubject$ | async as err; else innerLoading">
                    <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
                </div>
            </div>
        </div>
    </div>

    <ng-template #innerLoading>
        <div class="mt-4">
            <app-widget-placeholder></app-widget-placeholder>
        </div>
    </ng-template>

    <ng-template #linkToNewsCenter>
        <div class="col-auto mt-4 text-center" *ngIf="!loading">
            <span *ngIf="newsCenterUrl" i18n="@@more-news-in-news-center">For older news, open <app-action-link [href]="newsCenterUrl" [target]="'blank'">News Center</app-action-link></span>
            <span *ngIf="!newsCenterUrl" i18n="@@more-news-in-internal-news-center">For older news, open <app-action-router-link [routerLink]="'../pages/news'">News Center</app-action-router-link></span>
        </div>
    </ng-template>
</div>
